module.exports = __webpack_public_path__ + "static/media/bg_page17_b.2e25395c.jpg";